import React from 'react';
import pt from 'prop-types';
import { Typography } from '@metarouter-private/mr-mui';

export default function EmptyOrgList({ search, loading }) {
  if (loading) {
    return null;
  }

  const query = search.trim();
  const message = query === '' ? 'No other organizations' : `No organizations match "${query}"`;

  return (
    <Typography variant="body2" color="text.secondary" align="center" data-test-id="OrgSwitcherNoMatch">
      {message}
    </Typography>
  );
}

EmptyOrgList.propTypes = {
  search: pt.string.isRequired,
  loading: pt.bool.isRequired,
};
